import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { GenericRadioTextFilter } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextFilter';
import type { RadioTextFilterValueType } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/UserIdLabelFormatter';

const placeholders = {
  [RadioTextFilterOperation.IS]: 'Enter a Hotjar user ID',
  [RadioTextFilterOperation.IS_NOT]: 'Enter a Hotjar user ID',
};

export function UserIdFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<RadioTextFilterValueType>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.UserID);
  const { label1, label2 } = getLabels(currentValue);
  return (
    <GenericRadioTextFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      placeholders={placeholders}
      options={[RadioTextFilterOperation.IS, RadioTextFilterOperation.IS_NOT]}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      label1={label1}
      label2={label2}
      header="The unique anonymous identifier Hotjar assigns to all users."
    />
  );
}
